import { render, staticRenderFns } from "./ScrollCfg.vue?vue&type=template&id=248f9ee9&scoped=true&"
import script from "./ScrollCfg.vue?vue&type=script&lang=js&"
export * from "./ScrollCfg.vue?vue&type=script&lang=js&"
import style0 from "./ScrollCfg.vue?vue&type=style&index=0&id=248f9ee9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248f9ee9",
  null
  
)

export default component.exports